"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledWrapper = exports.StyledTextContainer = exports.StyledButton = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("../Button");
var _templateObject, _templateObject2, _templateObject3;
var StyledWrapper = exports.StyledWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: auto;\n  position: relative;\n  border: ", ";\n  margin-top: 10px;\n\n  video,\n  audio {\n    width: 100%;\n    height: 100%;\n    &::-webkit-media-controls {\n      display: none;\n    }\n  }\n  img {\n    width: auto;\n    height: 100%;\n    max-width: 200px;\n    max-height: 112px;\n  }\n"])), function (_ref) {
  var isStaged = _ref.isStaged,
    isLive = _ref.isLive;
  return isStaged ? '2px solid #fff' : isLive ? '2px solid #28865E' : 'none';
});
var StyledButton = exports.StyledButton = (0, _styledComponents["default"])(_Button.Button)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  cursor: ", ";\n  padding: 8px 12px;\n  background-color: ", ";\n  backdrop-filter: blur(4px);\n  border: none !important;\n  font-size: 14px;\n  color: ", ";\n  z-index: 2;\n  opacity: ", ";\n\n  &:active,\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    color: ", ";\n    outline: none !important;\n    box-shadow: none !important;\n  }\n"])), function (_ref2) {
  var $enableFeature = _ref2.$enableFeature,
    isDisabled = _ref2.isDisabled;
  return !$enableFeature || isDisabled ? 'not-allowed !important' : 'pointer';
}, function (_ref3) {
  var $isLive = _ref3.$isLive;
  return $isLive ? '#ffffff' : '#28865e';
}, function (_ref4) {
  var $isLive = _ref4.$isLive;
  return $isLive ? '#33373D' : '#ffffff';
}, function (_ref5) {
  var isDisabled = _ref5.isDisabled;
  return isDisabled ? 0.3 : 1;
}, function (_ref6) {
  var $isLive = _ref6.$isLive;
  return $isLive ? '#ffffff' : '#28865e';
}, function (_ref7) {
  var $isLive = _ref7.$isLive;
  return $isLive ? '#33373D' : '#ffffff';
});
var StyledTextContainer = exports.StyledTextContainer = _styledComponents["default"].section(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 158px;\n  margin: 0 auto;\n  text-align: center;\n  font-size: 12px;\n  line-height: 16px;\n"])));